var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemShareIconStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.82 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.78,13a1,1,0,0,0-1,1V24.37a1.56,1.56,0,0,1-1.55,1.56H3.63a1.56,1.56,0,0,1-1.56-1.56V14A1,1,0,1,0,0,14V24.37A3.64,3.64,0,0,0,3.63,28H19.19a3.64,3.64,0,0,0,3.63-3.63V14A1,1,0,0,0,21.78,13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,7l3.41-3.41V17.89a1,1,0,1,0,2.08,0V3.54L15.86,7a1,1,0,0,0,.73.31,1,1,0,0,0,.74-1.77L12.14.3A1,1,0,0,0,11.8.08a1,1,0,0,0-.79,0,1.11,1.11,0,0,0-.34.22L5.49,5.49A1,1,0,0,0,5.49,7,1,1,0,0,0,7,7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemShareIconStroke);
export default __webpack_public_path__ + "static/media/item_share_icon_stroke.8b53142db15933cb27ed81b6601210d5.svg";
export { ForwardRef as ReactComponent };